<script lang="ts">
  import { api, type PublicResult } from '../lib/api';
  import { date } from '../lib/format';
  import ResultPanel from '../components/ResultPanel.svelte';
  import SharePanel from '../components/SharePanel.svelte';
  let { id }: { id: string } = $props();
  let r = $state<PublicResult | null>(null);
  let err = $state('');
  $effect(() => {
    api<PublicResult>(`/v1/results/${encodeURIComponent(id)}`)
      .then((x) => (r = x))
      .catch((e) => (err = e.status === 404 ? 'Ce résultat n’existe pas ou a été supprimé.' : e.message));
  });
</script>

<h1>Résultat partagé</h1>
{#if err}
  <p class="notice bad">{err}</p>
{:else if r}
  <p class="muted">
    Test du {date(r.created_at)}{#if r.operator} · {r.operator}{/if}{#if r.commune} · {r.commune}{/if}{#if r.connection_type} · {r.connection_type}{/if}
    · méthode v{r.method_version}
  </p>
  <ResultPanel down={r.download_mbps} up={r.upload_mbps} latency={r.idle_ms} jitter={r.jitter_ms} loadedDown={r.loaded_down_ms} loadedUp={r.loaded_up_ms}
    grade={r.grade} loss={r.packet_loss} serverName={`${r.server_name}, ${r.server_city}`}
    warnings={r.stable ? [] : ['Mesure instable lors du test : résultat indicatif.']} />
  <div class="spaced"><SharePanel shareId={r.share_id} /></div>
  <p class="spaced"><a class="button primary" href="/">Faire mon propre test</a></p>
{:else}
  <p aria-busy="true">Chargement…</p>
{/if}

<style>
  .spaced { margin-top: 16px; }
</style>
